module.exports = ".medicalPlus {\r\n    z-index: 10;\r\n    left: -6px;\r\n    top: -2px;\r\n    font-size: 18px !important;\r\n    position: absolute;\r\n}\r\n.medicalHistory {\r\n    z-index: 9;\r\n    top: -3px;\r\n    font-size: 18px !important;\r\n    position: absolute;\r\n}\r\n.selectedColor {\r\n    color : #f15f79;\r\n}\r\n.defaultColor {\r\n    color : #434343 !important;\r\n}\r\ninput[type=text] {\r\n    padding-left : 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/patient/view-patient/view-patient.component.css
// module id = ./src/app/section/patient/view-patient/view-patient.component.css
// module chunks = main